import "../common/elements/Header.scss";
import translate from "@/i18n/translate";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";

export default function IncorrectURLComponent(): JSX.Element {
  const location = useLocation();
  const { institution } = useContext<AppContextInterface>(AppContext);
  const isPlanningRoute = location.pathname.includes('/planning/');
  const url = isPlanningRoute
    ? `/insights/planning/institution/${institution?.platformUuid}`
    : "/insights/home";

  return (
    <main className="main-content-home unauth-component">
      <div className="unauthorized-title">
        {translate("app.incorrect.title")}
      </div>
      <div className="unauth-desc">
        {translate("app.incorrect.goto")}
        <a href={url}>{translate("app.incorrect.home")}</a>
      </div>
    </main>
  );
}
